var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".35vw",
    height: ".5vw",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99999 10L0.937988 8.938L4.87499 5L0.937988 1.062L1.99999 0L6.99999 5L1.99999 10Z",
    fill: "#293050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.b66642df9fd871fbf9061886705827fa.svg";
export { ForwardRef as ReactComponent };